import { render } from "./WidgetBarChart.vue?vue&type=template&id=5d65fe89"
import script from "./WidgetBarChart.vue?vue&type=script&lang=js"
export * from "./WidgetBarChart.vue?vue&type=script&lang=js"

import "./WidgetBarChart.vue?vue&type=style&index=0&id=5d65fe89&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Charts/WidgetBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d65fe89"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d65fe89', __exports__)) {
    api.reload('5d65fe89', __exports__)
  }
  
  module.hot.accept("./WidgetBarChart.vue?vue&type=template&id=5d65fe89", () => {
    api.rerender('5d65fe89', render)
  })

}


export default __exports__